import React, { useEffect, useMemo } from "react";

import { makeStyles } from "@material-ui/core";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

import { getTitle } from "app/common/utils/Logo";

import { AppLogo } from "./icons";
import { useRouteMatch } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  appInfoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    flex: 1,
    height: "100%",
    padding: "0 4rem",
  },
  exampleContainer: {
    padding: "1rem",
  },
  headerTitleRoot: {
    width: "100%",
    paddingTop: "0.5rem",
  },
  headerTitle: {
    fontSize: 16,
    margin: 0,
    color: (props) => props.themeColor || theme.palette.primary.main,
    marginBottom: 4,
  },
  appIcon: {
    cursor: "auto !important",
    fill: (props) => props.themeColor || theme.palette.primary.main,
  },
  infoContainer: {
    padding: "1rem 0",
    color: "#434343",
    fontSize: 14,
  },
  exampleLabel: {
    fontWeight: 500,
    margin: 0,
  },
  exampleListItem: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "12px",
    margin: "0.5rem 0",
  },

  exampleItemText: {
    color: "#434343",
  },
}));


const QUERY_EXAMPLES_INSIDE_PACK = [
  {
    query: `Add a sheet to maintain my student records. Make sure to include the following fields: First name, Last name, Standard ... `,
  },
  {
    query: `Add Quantity, Price and Total Amount fileds in this sheet.`,
  },
  {
    query: `I would like to share this sheet with sarah@example.com, john@gmail.com and ashu@facebook.com as an Admin Users.`,
  }
]

const QUERY_EXAMPLES = [
  {
    query: `I would like to build a CRM to track my sales leads. My business is ...`,
  },
  { query: `I would like to track my inventory. Our business ...` },
  {
    query: `Create a sheet to maintain my employee records. Make sure to include the following fields: First name, Last name, Date of joining ... `,
  },
  {
    query: `I'm thinking of creating a membership management system for my organization to streamline subscription renewals and member communications. My organization deals with ...`,
  },
];

export default function ChatIntro(props) {
  const { themeColor, assistantConfig, onCopyQuery } = props;

  const classes = useStyles({ themeColor });

  const appTitle = useMemo(() => <>{getTitle()} AI Assistant</>, []);

  const assistantAboutInfo = useMemo(() => {
    if (
      assistantConfig.about.stage === "release" ||
      assistantConfig.about.stage === "stable release"
    )
      return null;
    return <p>{assistantConfig.about.infoMessage}</p>;
  }, []);

  const routeMatch = useRouteMatch(
    "/pack/:packIdFromRoute/list/:sheetIdFromRoute"
  );

  const { packIdFromRoute, sheetIdFromRoute } = routeMatch?.params || {};

  const handleCopyExampleCommand = (query) => (e) => {
    onCopyQuery(query, e);
  };

  useEffect(() => {}, [packIdFromRoute]);

  const renderChatIntro = () => {
    return (
      <div className={classes.container}>
        <div className={classes.appInfoContainer}>
          <div style={{ fontSize: 60 }}>
            <AppLogo
              color="primary"
              fontSize="inherit"
              className={classes.appIcon}
            />
          </div>
          <div className={classes.headerTitleRoot}>
            <h2 className={classes.headerTitle}>{appTitle}</h2>
          </div>
          <div className={classes.infoContainer}>
            <p>
              I am an AI Assistant. you can write your queries for sheets
              generation, adding columns, etc.
            </p>
            {assistantAboutInfo}
          </div>
        </div>
        <div className={classes.exampleContainer}>
          <p className={classes.exampleLabel}>Try these examples:</p>
          <div>
            <List>
              {(!packIdFromRoute ? QUERY_EXAMPLES : QUERY_EXAMPLES_INSIDE_PACK ).map((example, i) => {
                return (
                  <React.Fragment key={i}>
                    <ListItem
                      className={classes.exampleListItem}
                      button
                      onClick={handleCopyExampleCommand(example.query)}
                    >
                      <ListItemText
                        classes={{ primary: classes.exampleItemText }}
                        primary={example.query}
                        secondary={""}
                      />
                      <FileCopyOutlinedIcon fontSize="small" />
                    </ListItem>
                  </React.Fragment>
                );
              })}
            </List>
          </div>
        </div>
      </div>
    );
  };

  return renderChatIntro();
}

ChatIntro.propTypes = {};

ChatIntro.defaultProps = {};
